import categories from '@/store/categories';
import NotYetImplemented from '@/views/NotYetImplemented.vue';
import { en } from 'vuetify/locale';

export default {
  welcome: 'Welcome back',
  accounts: 'Accounts',
  account: 'Account',
  dashboard: "Dashboard",
  loading: 'Loading...',
  products: "Products",
  suppliers: "Suppliers",
  customers: "Customers",
  users: "Users",
  product: "Product",
  productStatus: "Product status",
  newProduct: "New product",
  errorCreateProduct: "Error creating product, check all fields again.",
  errorUpdateProduct: "Error updating product, check all fields again.",
  errorDeleteProduct: "Error deleting product.",
  regulationSuccess: "Regulation successful",
  regulationError: "Regulation error, check all fields again.",
  regulateQuantity: "Regulate quantity",
  restock: "Restock",
  editProduct: "Edit product",
  deleteProduct: "Delete product",
  productCreated: "Product created",
  productUpdated: "Product updated",
  productDeleted: "Product deleted",
  editLocation: "Edit location",
  deleteLocation: "Delete location",
  addSubtract: "Add / Subtract",
  locationCreated: "Location created",
  locationUpdated: "Location updated",
  locationDeleted: "Location deleted",
  missingLocation: "Missing location",
  newLocation: "New location",
  movementFrom: "Movement from",
  cancel: "Cancel", 
  move: "Move",
  currentStock: "Current stock",
  stockRegulations: "Stock regulations",
  quantityToNove: "Quantity to move",
  errorCreateLocation: "Error creating location, check all fields again.",
  errorUpdateLocation: "Error updating location, check all fields again.",
  errorDeleteLocation: "Error deleting location.",
  locations: "Locations",
  location: "Location",
  newSupplier: "New supplier",
  editSupplier: "Edit supplier",
  deleteSupplier: "Delete supplier",
  supplierCreated: "Supplier created",
  supplierUpdated: "Supplier updated",
  supplierDeleted: "Supplier deleted",
  newCustomer: "New customer",
  editCustomer: "Edit customer",
  deleteCustomer: "Delete customer",
  customerCreated: "Customer created",
  customerUpdated: "Customer updated",
  customerDeleted: "Customer deleted",
  companyNumber: "Company number",
  companyName: "Company name",
  address1: "Address 1",
  address2: "Address 2",
  city: "City",
  zipCode: "Zip code",
  country: "Country",
  contactPhone: "Contact phone",
  contactEmail: "Contact email",
  contactPerson: "Contact person",
  newPurchase: "New purchase",
  supplier: "Supplier",
  customer: "Customer",
  purchases: "Purchases",
  purchase: "Purchase",
  sales: "Sales",
  sale: "Sale",
  user: "User",
  about: "About Capture IT",
  orders: "Orders",
  inventory: "Inventory",
  reports: "Reports",
  priceValue: "Stock value",
  stockValue: "Stock value",
  regulations: "Stock Regulations",
  stockMovements: "Stock Movements",
  checkingDrafts: "Checking Drafts",
  locations: "Locations",
  location: 'Location',
  locationName: 'Location name',
  locationNumber: 'Location number',
  defaultLocation: 'Default location',
  mandatoryDefaultLocation: '*Default location',
  supplier: 'Supplier',
  customer: 'Customer',
  number: 'Number',
  name: 'Name',
  selectRemoveAll: 'Select / Remove all',
  accountNumber: 'Account number',
  fullname: 'Full name',
  email: 'Email',
  role: 'Role',
  actions: 'Actions',
  general: 'General',
  other: 'Other',
  update: 'Update',
  image: 'Image',
  productImage: 'Product image',
  barcode: 'Barcode',
  quantity: 'Quantity',
  labelQuantity: 'Quantity labels',
  price: 'Price',
  pricePerUnit: 'Price per unit',
  salesPrice: 'Sales price',
  purchasePrice: 'Purchase price',
  total: 'Total',
  productName: 'Product name',
  mandatoryProductName: '*Product name',
  productNumber: 'Product number',
  mandatoryProductNumber: '*Product number',
  productGroup: 'Product group',
  stock: 'Stock',
  minStock: 'Minimum stock',
  status: 'Status',
  published: 'Published',
  scheduled: 'Scheduled',
  inactive: 'Inactive',
  date: 'Date',
  description: 'Description',
  height: 'Height',
  width: 'Width',
  depth: 'Depth',
  weight: 'Weight',
  quantity: 'Quantity',
  usersPerPageText: 'Users per page:',
  productsPerPageText: 'Products per page:',
  locationsPerPageText: 'Locations per page:',
  suppliersPerPageText: 'Suppliers per page:',
  customersPerPageText: 'Customers per page:',
  purchasesPerPageText: 'Purchases per page:',
  itemsPerPageText: 'Items per page:',
  salesPerPageText: 'Sales per page:',
  ordersPerPageText: 'Orders per page:',
  of: 'of',
  to: 'to',
  on: 'on',
  quantity: 'Quantity',
  one: 'one',
  note: 'Note',
  pageText: '{0} - {1} of {2}',
  fullnameMandatory: 'Full name is mandatory',
  emailInvalid: 'Invalid email',
  userMandatory: 'Username and password are mandatory',
  emailMandatory: 'Email is mandatory',
  userCreated: 'User created!',
  errorCreateUser: 'Error creating user, check all fields again.',
  userdeleted: 'User has been deleted',
  errorDeleteUser: 'Error deleting user',
  appname: 'PicklyWMS',
  login: 'Login',
  settings: 'Settings',
  importExport: 'Import / Export',
  import: 'Import',
  export: 'Export',
  importProducts: 'Import products',
  exportProducts: 'Export products',
  uploadFile: 'Upload file',
  uploadFileText: 'Drag and drop an Excel or CSV file here.',
  uploadSucceded: 'Upload succeeded',
  uploadFailed: 'Upload failed',
  language: 'Language',
  darkMode: 'Dark mode',
  showProducts: 'Show inactive products',
  showLocations: 'Show inactive locations',
  other: 'Other',
  selectLanguage: 'Select language',
  english: 'English',
  danish: 'Danish',
  swedish: 'Swedish',
  norwegian: 'Norwegian',
  finnish: 'Finnish',
  enabled: 'Enabled',
  disabled: 'Disabled',
  required: 'Required',
  optional: 'Optional',
  username: 'Username',
  password: 'Password',
  print: 'Print',
  printSelected: 'Print selected',
  close: 'Close',
  save: 'Save',
  cancel: 'Cancel',
  reset: 'Reset',
  clear: 'Clear',
  create: 'Create',
  edit: 'Edit',
  delete: 'Delete',
  confirmDelete: 'Delete confirmation',
  deleteWarningUser: 'Are you sure you want to delete this user?',
  deleteWarningProduct: 'Are you sure you want to delete this product?',
  error: 'Error',
  success: 'Success',
  info: 'Info',
  warning: 'Warning',
  submit: 'Submit',
  search: 'Search',
  newUser: 'New user',
  editUser: 'Edit user',
  deleteUser: 'Delete user',
  userCreated: 'User created',
  userDeleted: 'User deleted',
  userUpdated: 'User updated',
  oneRegistered: 'There is one registered',
  thereAreXRegistered: 'There are registered',
  weHaveOneRegistered: 'We have registered one',
  weHaveXRegistered: 'We have registered',
  warehouseManagement: 'Warehouse management',
  trade: 'Trade',
  NotYetImplemented: 'Not yet implemented',
  notYetImplementedText: 'This feature is not yet implemented. Please check back later or contact support for more information.',
  goBack: 'Go back',
  categories: 'Categories',
  category: 'Category',
  newCategory: 'New category',
  editCategory: 'Edit category',
  deleteCategory: 'Delete category',
  categoryCreated: 'Category created',
  categoryUpdated: 'Category updated',
  categoryDeleted: 'Category deleted',
  errorCreateCategory: 'Error creating category, check all fields again.',
  errorUpdateCategory: 'Error updating category, check all fields again.',
  errorDeleteCategory: 'Error deleting category.',
  mandatoryCategoryName: '*Category name',
  categoryName: 'Category name',
  categoryDescription: 'Category description',
  categoriesPerPageText: 'Categories per page:',
  usePrintServer: "Use Print Server (Silent Printing)",
  printJobSent: "Print job sent to server.",
  printJobsSent: "All print jobs sent to server.",
  printJobFailed: "Print job failed",
  printServerConnectionError: "Could not connect to print server. Is it running?",
  printBatchFailed: "Print batch failed. At least one job could not be sent.",
  noLabelSelectedError: "No label design selected.",
  onlyInStock: "Only in-stock products",
  valueFromCostPrice: "Value based on cost price"
};